/**
 * TODO: This enum must be removed.
 *       It is already implemented in the common domain.
 */
export enum Nationality {
  American = 'american',
  Mexican = 'mexican',
  Other = 'other',
}
